const getSearchedClients = (state) => {
  // state.client é null até um cliente ser selecionado (ex.: contexto gestão em
  // /clientes). Sem a guarda, `state.client.id` lança TypeError e quebra todo
  // consumidor do histórico. Com currentId null, nenhum recente é filtrado.
  const currentId = state.client && state.client.id
  return state.clients.filter((v) => {
    return v.id !== currentId
  })
}

// Histórico completo de acessos (MRU, cliente atual no topo), SEM remover o
// cliente selecionado. Ao contrário de getSearchedClients — que oculta o atual
// pro dropdown do switcher (onde não faz sentido listar o cliente já aberto) —
// a faixa "Acessados recentemente" da tela de gestão deve incluir o último
// acessado.
const recentClients = (state) => {
  return state.clients
}

const currentClient = (state) => {
  return state.client
}

const currentUser = (state) => {
  return state.user || {}
}

export const loadingUser = (state) => {
  return state.loading_user
}

const allClients = (state) => {
  return state.clientes
}

const emails = (state) => {
  return state.emails
}

const clientDatas = (state) => {
  return state.clientDatas
}

const clientInfo = (state) => {
  return state.clientInfo
}

const hasIncompletesAssets = (state) => {
  return state.has_incompletes_assets
}

export {
  getSearchedClients,
  recentClients,
  currentClient,
  currentUser,
  clientDatas,
  allClients,
  emails,
  clientInfo,
  hasIncompletesAssets,
}
